import { render, staticRenderFns } from "./NewRecommededCourse.html?vue&type=template&id=1e445409&scoped=true&external"
import script from "./NewRecommendedCourse.vue?vue&type=script&lang=js"
export * from "./NewRecommendedCourse.vue?vue&type=script&lang=js"
import style0 from "./NewRecommendedCourses.scss?vue&type=style&index=0&id=1e445409&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e445409",
  null
  
)

export default component.exports